import { Color, DefaultValue, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

const invertedBackgroundColor = Color.Green900

interface DropdownHeaderWrapperProps {
  isInverted?: boolean
}

export const DropdownHeaderWrapper = styled.div<DropdownHeaderWrapperProps>`
  padding: ${Spacing.S4};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};

  ${({ isInverted }) =>
    isInverted &&
    css`
      background-color: ${invertedBackgroundColor};
    `}
`

interface DropdownHeaderItemProps {
  isSelected: boolean
  isInverted?: boolean
}

export const DropdownHeaderItemWrapper = styled.div<DropdownHeaderItemProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S4};

  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: ${Color.Grey200};
    border-radius: ${DefaultValue.BorderRadius};
  `}

  &:hover {
    border-radius: ${DefaultValue.BorderRadius};
    background-color: ${Color.Grey200};
    cursor: pointer;
  }

  ${({ isInverted }) =>
    isInverted &&
    css`
      background-color: ${invertedBackgroundColor};

      &:not(:disabled):hover {
        background-color: ${Color.Green800};
      }
    `}
`

interface AccessorListItemProps {
  isInverted?: boolean
}

export const AccessorListItem = styled.li<AccessorListItemProps>`
  padding: ${Spacing.S4} ${Spacing.S8};

  ${({ isInverted }) =>
    isInverted &&
    css`
      background-color: ${invertedBackgroundColor};
    `}
`
